<h3 class="with-manual-link">
  <span i18n="@@chat-bot">Chat-Bot</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Konfiguration/Chat-Bot"
  ></app-manual-link>
</h3>
<app-submenu [items]="this.submenuService.SUBMENU_FOR_CONFIGURATION"></app-submenu>
<app-form-for-boolean
  [label]="this.showPrompt"
  [(value)]="this.rss.botConfig.promptbarChatActive"
  [colClass]="'col-3'"
  (valueChange)="this.rss.saveBotConfigField('promptbarChatActive')"
></app-form-for-boolean>
<h3
  class="mt-4"
  i18n="@@prompt-options"
>Eingabezeile</h3>
<div class="card border-0">
  <div class="card-body">
    <app-form-for-boolean
      [label]="this.voiceInput"
      [(value)]="this.rss.botConfig.voiceInputChatActive"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('voiceInputChatActive')"
    >
      <app-hint i18n="@@hint-mic-usage">
        Ermöglicht Nutzereingabe über Mikrofon
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.redirectAvatar"
      [(value)]="this.rss.botConfig.switchToAvatarFromChat"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('switchToAvatarFromChat')"
    >
      <app-hint i18n="@@hint-swap-to-avatar">
        Zusätzlicher Knopf, um zum Avatar-Bot zu wechseln
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.redirectVoice"
      [(value)]="this.rss.botConfig.switchToVoiceFromChat"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('switchToVoiceFromChat')"
    >
      <app-hint i18n="@@hint-swap-to-voice">
        Zusätzlicher Knopf, um zum Audio-Bot zu wechseln
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.cancelThinking"
      [(value)]="this.rss.botConfig.cancelBotThinkingChatActive"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('cancelBotThinkingChatActive')"
    >
      <app-hint i18n="@@hint-cancel-thinking">
        Aktuell laufende Bot-Bearbeitung abbrechen
      </app-hint>
    </app-form-for-boolean>
  </div>
</div>
<h3
  class="mt-4"
  i18n="@@message-options"
>Nachrichten</h3>
<div class="card border-0">
  <div class="card-body">
    <app-form-for-boolean
      [label]="this.humanFeedback"
      [(value)]="this.rss.botConfig.enableMessageFeedback"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('enableMessageFeedback')"
    >
      <app-hint i18n="@@hint-chat-feedback">
        Fügt an Botnachrichten Knöpfe für positives/negatives Feedback hinzu
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.copyMessage"
      [(value)]="this.rss.botConfig.messageCopyChatActive"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('messageCopyChatActive')"
    >
      <app-hint i18n="@@hint-chat-copy">
        Fügt an Botnachrichten einen Knopf zum Kopieren des Inhalts hinzu
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.deleteMessage"
      [(value)]="this.rss.botConfig.messageDeleteChatActive"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('messageDeleteChatActive')"
    >
      <app-hint i18n="@@hint-chat-delete">
        Fügt an allen Nachrichten einen Knopf zum Löschen der spezifischen Nachricht hinzu
      </app-hint>
    </app-form-for-boolean>
    <app-form-for-boolean
      [label]="this.voiceOutput"
      [(value)]="this.rss.botConfig.voiceOutputChatActive"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('voiceOutputChatActive')"
    >
      <app-hint i18n="@@hint-chat-playmsg">
        Fügt an Botnachrichten einen Knopf zum Abspielen des Inhalt mit einem Sprachmodel hinzu
      </app-hint>
    </app-form-for-boolean>


    <app-form-for-boolean
      [label]="this.activateWebSearch"
      [(value)]="this.rss.botConfig.websearch"
      [colClass]="'col-3'"
      [isDisabled]="this.rss.botConfig.modelSource === 'vllm'"
      (valueChange)="this.rss.saveBotConfigField('websearch')"
    >
      <app-hint i18n="@@hint-deep-research">
        Aktiviert das Deep Research Feature für den Chat-Bot, welches es dem Bot ermöglicht, komplexe Recherchen
        durchzuführen. Diese Funktion steht nur für OpenAI-Modelle zur Verfügung.
      </app-hint>
    </app-form-for-boolean>

    <div class="row align-items-center">
      <div class="col-3">
        <span i18n="@@reasoning-effort">Reasoning-Aufwand</span>
        <app-hint i18n="@@reasoning-effort-hint">Reasoning-Aufwand bestimmt, wie intensiv das Modell über eine Aufgabe
          nachdenkt. Niedrige Werte sind schneller, hohe Werte können bei komplexen Aufgaben bessere Ergebnisse
          liefern.</app-hint>
      </div>
      <div class="col-auto">
        <p-select
          [options]="getReasoningEffortOptions()"
          optionLabel="name"
          optionValue="value"
          [(ngModel)]="this.rss.botConfig.reasoningEffort"
          [ngModelOptions]="{ updateOn: 'blur' }"
          (ngModelChange)="this.rss.saveBotConfigField('reasoningEffort');"
          [disabled]="!isReasoningModel(this.rss.botConfig.model) && !this.rss.botConfig.model.startsWith('Qwen')"
        ></p-select>
      </div>
    </div>


  </div>
</div>
<h3
  class="mt-4"
  i18n="@@user-documents-heading"
>Nutzer-Dokumente</h3>
<div class="card border-0">
  <div class="card-body">
    <app-form-for-boolean
      [label]="this.activateUserDocuments"
      [(value)]="this.rss.botConfig.userDocumentsEnabled"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('userDocumentsEnabled')"
    >
      <app-hint i18n="@@hint-user-documents">
        Ermöglicht es Nutzern, eigene Dokumente hochzuladen und im Chat zu durchsuchen.
      </app-hint>
    </app-form-for-boolean>
    @if (this.rss.botConfig.userDocumentsEnabled) {
    <div class="row mt-3">
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@user-documents-max-count"
        >Maximale Anzahl Dokumente</label>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.userDocumentsMaxCount"
          [min]="0"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('userDocumentsMaxCount')"
        ></p-inputnumber>
        <small
          class="text-muted"
          i18n="@@user-documents-max-count-hint"
        >0 = kein Limit</small>
      </div>
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@user-documents-max-mb"
        >Maximale Dateigröße (MB)</label>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.userDocumentsMaxMb"
          [min]="0"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('userDocumentsMaxMb')"
        ></p-inputnumber>
        <small
          class="text-muted"
          i18n="@@user-documents-max-mb-hint"
        >0 = kein Limit</small>
      </div>
    </div>
    <div class="mt-3">
      <app-form-for-boolean
        [label]="this.userDocumentsMemoryLabel"
        [(value)]="this.rss.botConfig.userDocumentsMemoryEnabled"
        [colClass]="'col-3'"
        (valueChange)="this.rss.saveBotConfigField('userDocumentsMemoryEnabled')"
      >
        <app-hint i18n="@@hint-user-documents-memory">
          Merkt sich Ergebnisse vergangener Suchen in den Nutzer-Dokumenten im Gespräch, damit Wissen aus
          früheren Suchen bei späteren Nachrichten erhalten bleibt.
        </app-hint>
      </app-form-for-boolean>
    </div>
    @if (this.rss.botConfig.userDocumentsMemoryEnabled) {
    <div class="row mt-3">
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@doc-search-memory-limit"
        >Anzahl gemerkter Suchen</label>
        <app-hint i18n="@@doc-search-memory-limit-hint">Ältere Suchen werden nicht verworfen, sondern automatisch
          zusammengefasst.</app-hint>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.userDocumentsMemoryLimit"
          [min]="1"
          [max]="10"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('userDocumentsMemoryLimit')"
        ></p-inputnumber>
      </div>
    </div>
    }
    }
  </div>
</div>
<h3
  class="mt-4"
  i18n="@@css-individual"
>Individueller CSS</h3>
<div class="card border-0">
  <div class="card-body">
    <app-codemirror-css
      [instruction]="this.rss.botConfig.customChatCss"
      [rows]="13"
      [botlyContext]="'Chat-Bot'"
      [placeholder]="this.enterCustomCss"
      (finish)="this.rss.botConfig.customChatCss = $event; this.rss.saveBotConfigField('customChatCss')"
    ></app-codemirror-css>
  </div>
</div>